// extracted by mini-css-extract-plugin
export var content = "styles-module--content--2KjBm";
export var contentHeader = "styles-module--content-header--3XBaW";
export var contentList = "styles-module--content-list--2Yjid";